import styled from '@emotion/styled';
import {
  Divider,
  device,
  typography,
  mobileGutterMargin,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React from 'react';
import { animated } from 'react-spring';
import type { ImgSource, ImgAr } from '../../components/img/Img';
import { Img } from '../../components/img/Img';

export const Host = styled(animated.div, {
  shouldForwardProp: shouldForwardProp('div'),
})`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  background-color: ${(props) => props.theme.colors.background};
`;

const ImageWrap = styled.div`
  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};
  margin-bottom: 2em;

  ${mobileGutterMargin}

  @media ${device.tablet} {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

const Name = styled.h2`
  ${typography.h3};
`;

const Title = styled.div``;

const Location = styled.div``;

const Email = styled.a`
  text-transform: lowercase;

  &:hover {
    opacity: 0.8;
  }
`;
const Phone = styled.a`
  &:hover {
    opacity: 0.8;
  }
`;

export interface CardProps {
  staffImage?: ImgSource;
  ar?: ImgAr;
  name: string | null;
  title: string | null;
  email: string | null;
  phone: string | null;
  location?: string;
  hasImage?: boolean;
  percentage?: number;
}

export const StaffCard = ({
  staffImage,
  ar = 'ar_1_1',
  name,
  title,
  email,
  phone,
  location,
  hasImage,
  percentage,
  ...rest
}: CardProps) => {
  // Remove everything not number
  const strippedNumber = (phone || '').replace(/\D+/g, '');
  // Add space after 3rd number
  const formatedNumber = strippedNumber.replace(/^(.{3})(.*)$/, '$1 $2');
  return (
    <Host {...rest}>
      {!!staffImage && hasImage && (
        <ImageWrap>
          <Img src={staffImage} ar={ar} percentage={percentage} />
        </ImageWrap>
      )}
      <Name>{name}</Name>
      <Divider margin="18px 0 16px" />
      <Title>{title}</Title>
      {!!location && <Location>{location}</Location>}
      <Email href={`mailto:${email}`} target="_blank" rel="noopener">
        {email}
      </Email>
      <Phone href={`tel:${phone}`}>{formatedNumber}</Phone>
    </Host>
  );
};
